<template>
    <page>
        <module title="平台配置">
            <c-form ref="form" unit-width="40%">
                <div class="form-title">备案信息</div>
                <c-form-item label="版权信息">
                    <c-input name="platform_copyright_info" maxlength="500"></c-input>
                </c-form-item>
                <c-form-item label="ICP备案号">
                    <c-input name="platform_icp_record_no" maxlength="100"></c-input>
                </c-form-item>
                <c-form-item label="公安备案号">
                    <c-input name="platform_public_security_record_no" maxlength="100"></c-input>
                </c-form-item>
                <c-form-item label="公安备案链接">
                    <c-input name="platform_public_security_record_url" maxlength="500"></c-input>
                </c-form-item>
                <c-form-item label="增值电信业务经营许可证">
                    <c-input name="platform_telecom_license_name" maxlength="500"></c-input>
                </c-form-item>
                <c-form-item label="增值电信业务经营许可证图片">
                    <c-upload-file name="platform_telecom_license_image" type="image" size="10240" button="上传图片" maxlength="500"></c-upload-file>
                </c-form-item>

                <div class="form-title">导航</div>
                <c-form-item label="官网地址">
                    <c-input name="platform_official_website_url" maxlength="500"></c-input>
                </c-form-item>
                <c-form-item label="官微二维码">
                    <c-upload-file name="platform_wechat_qrcode_url" type="image" size="5120" button="上传二维码" media></c-upload-file>
                </c-form-item>
                <c-form-item label="小程序二维码">
                    <c-upload-file name="platform_mini_program_qrcode_url" type="image" size="5120" button="上传二维码" media></c-upload-file>
                </c-form-item>
                <c-form-item label="客服二维码">
                    <c-upload-file name="platform_service_qrcode_url" type="image" size="5120" button="上传二维码" media></c-upload-file>
                </c-form-item>
                <c-form-item label="客服电话">
                    <c-input name="platform_service_phone" maxlength="500"></c-input>
                </c-form-item>

                <div class="form-title">渠道授权配置</div>
                <!-- 注意：SystemConfigMapper 里对 config_item_code 做了 LOWER() 处理，
                     接口返回的编码统一为小写，这里 name 必须保持小写才能与 set() 匹配上 -->
                <c-form-item label="闲鱼授权链接">
                    <c-input name="channel_auth_url_goofish" maxlength="500" placeholder="固定 OAuth 链接，无占位符"></c-input>
                </c-form-item>
                <c-form-item label="采货侠授权链接">
                    <c-input name="channel_auth_url_chx" maxlength="500" placeholder="支持占位符 {nickName} {phone}"></c-input>
                </c-form-item>
                <c-form-item label="京东授权链接">
                    <c-input name="channel_auth_url_jd" maxlength="500" placeholder="支持占位符 {nickName} {phone}"></c-input>
                </c-form-item>
                <c-form-item label="转转授权链接">
                    <c-input name="channel_auth_url_zz" maxlength="500" placeholder="支持占位符 {nickName} {phone}"></c-input>
                </c-form-item>
                <c-form-item label="天翼授权链接">
                    <c-input name="channel_auth_url_tianyi" maxlength="500" placeholder="支持占位符 {nickName} {phone}"></c-input>
                </c-form-item>

                <div class="form-title">商城配置</div>
                <c-form-item label="订单取消时间">
                    <c-input name="platform_order_cancel_time" type="number" decimal="0" :range="[0, 999999]" append-text="分" :clear="false"></c-input>
                </c-form-item>
                <c-form-item label="暗拍保证金">
                    <c-input name="platform_ap_deposit" type="number" decimal="2" :range="[0, 999999]" append-text="元" :clear="false"></c-input>
                </c-form-item>
                <c-form-item label="暗拍违约金">
                    <c-input name="platform_ap_dedit" type="number" decimal="2" :range="[0, 999999]" append-text="元" :clear="false"></c-input>
                </c-form-item>
                <c-form-item label="暗拍开始时间">
                    <c-datetime name="platform_ap_start_time" type="time"></c-datetime>
                </c-form-item>
                <c-form-item label="暗拍结束时间">
                    <c-datetime name="platform_ap_end_time" type="time"></c-datetime>
                </c-form-item>
				<c-form-item label="暗拍截单时间" tip="暗拍每日截止付款时间">
					<c-datetime name="platform_ap_pay_limit_time" type="time"></c-datetime>
				</c-form-item>

                <div class="form-title">其他</div>
                <c-form-item label="到期提醒天数">
                    <c-input name="platform_expiration_reminder_days" maxlength="500"></c-input>
                </c-form-item>
            </c-form>

            <template #button>
                <c-button color="main" size="form" @click="save">保存</c-button>
            </template>
        </module>
    </page>
</template>

<script>
import CUploadFile from "@/components/extend/upload_file.vue";

export default {
    name: 'm_system_platform_config',
    components: {CUploadFile},

    mounted() {
        this.getDetail();
    },

    methods: {
        /******加载平台配置*********/
        getDetail() {
            this.request({
                url: '/platform_config/list',
                data: {},
                loading: true,
                success: data => {
                    const formData = {};
                    data.forEach(item => {
                        formData[item.config_item_code] = item.config_item_value;
                    });
                    this.$nextTick(() => this.$refs.form.set(formData));
                },
            });
        },

        /******保存平台配置*********/
        save() {
            const formData = this.$refs.form.get();
            const configList = Object.keys(formData).map(key => ({
                config_item_code: key,
                config_item_value: formData[key] ? formData[key].toString() : '',
            }));
            this.request({
                url: '/platform_config/edit',
                data: {
                    config_list: configList,
                },
                loading: true,
                success: () => this.$message({message: '保存成功', type: 'success'}),
            });
        },
    },
};
</script>

<style lang="stylus" scoped>
.button-bar
    padding 20px

.form-title
    margin 0 0 16px
    font-size 16px
    font-weight 600

.form-title:not(:first-child)
    margin-top 32px
</style>
